module.exports = __webpack_public_path__ + "img/fareupload.f74970a7.svg";